import { getSVG } from './components/icons-loader.js';
import { slickSliderGenerator } from './components/sliders.js';
import { displayCookieBanner } from './components/cookies-banner.js';

document.addEventListener("DOMContentLoaded", async function () {
  slickSliderGenerator('products', '.products-container');
  slickSliderGenerator('features', '.features-container');
  getSVG();
  displayCookieBanner();
});

